var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-43.8%",
    y1: "-41.579%",
    x2: "102%",
    y2: "101%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAA27B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#978129",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 1.155 13.32 7.69a4 4 0 0 1 2 3.464v15.382a4 4 0 0 1-2 3.464L20 38.845a4 4 0 0 1-4 0l-13.32-7.69a4 4 0 0 1-2-3.464V12.309a4 4 0 0 1 2-3.464L16 1.155a4 4 0 0 1 4 0z",
    fill: "url(#a)",
    transform: "translate(2)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.568 11.116 1.736-.048c2.23-.062 3.327-.067 4.574.013 1.714.11 3.137.389 4.374.915 3.12 1.325 4.732 4.121 4.692 8.462l-.002.074c-.21 4.161-1.709 6.76-4.527 7.95-1.143.482-2.442.71-4.024.77-1.123.041-1.972.014-4.25-.105l-.872-.044-1.701-.082V11.116zm3.572 3.487V25.62c3.364.157 4.694.075 5.886-.428 1.422-.6 2.195-1.934 2.346-4.803.02-2.943-.815-4.38-2.517-5.105-1.285-.546-2.768-.712-5.715-.68z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.033 18.518h9.445v3.3h-9.445z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/doge.ffa205a9c7f108d3c0f03069c5a5a06a.svg";
export { ForwardRef as ReactComponent };